import { COUNTRY } from '@/config';
import logger from '@/utils/logger';

function mountZendeskTags({
  department,
  primaryReason,
  secondaryReason,
  product,
  whmcsId,
  departmentLocales,
  priority,
  isTicket,
  v2,
}) {
  const isTechnicalDepartment = department === 'technical';
  const isFinancialDepartment = department === 'financial';
  const isPriorityDepartment = department === 'priority';
  const mountedTags = [];
  let zendeskDepartment;

  const noProductSelected = product === '&noproductselected=true';
  if (noProductSelected && !v2) {
    mountedTags.push('other_product_selected');
  }

  if (isFinancialDepartment && secondaryReason === 'cancel-with-support') {
    mountedTags.push('cliente_cancelamento_fluxo_retencao');
    mountedTags.push(`product_id: ${product}`);
  }

  if (!isTechnicalDepartment && !v2) {
    zendeskDepartment = departmentLocales.financial;
  }

  if (isTechnicalDepartment && !v2) {
    zendeskDepartment = departmentLocales.shared;
  }

  if (isTechnicalDepartment && primaryReason === 'technical-others' && !v2) {
    zendeskDepartment = departmentLocales.shared;
  }

  if (isTechnicalDepartment && primaryReason === 'dns' && !v2) {
    zendeskDepartment = departmentLocales.domain;
  }

  if (isTechnicalDepartment && primaryReason === 'email' && !v2) {
    zendeskDepartment = departmentLocales.mail;
  }

  if (isTechnicalDepartment && (primaryReason === 'wordpress-tool' || primaryReason === 'site-offline') && !v2) {
    zendeskDepartment = departmentLocales.builder;
  }

  if (isTechnicalDepartment && (primaryReason === 'site-offline' && secondaryReason === 'site-tos') && !v2) {
    zendeskDepartment = departmentLocales.tos;
  }

  if (department === 'skilled') {
    zendeskDepartment = departmentLocales.skilled;
  }

  if (isPriorityDepartment) {
    zendeskDepartment = departmentLocales.priority;
  }

  if (secondaryReason) {
    mountedTags.push(secondaryReason);
  }

  if (primaryReason) {
    mountedTags.push(primaryReason);
  } else {
    logger.error('chat without tag', {
      primaryReason,
      department,
      secondaryReason,
      whmcsId,
    });
  }

  if (priority) {
    mountedTags.push(`priority_${priority}`);
  }

  if (COUNTRY === 'br' && !isFinancialDepartment && !isPriorityDepartment) {
    mountedTags.push(isTicket ? 'hg_messaging_email' : 'hg_messaging_chat');
  }

  mountedTags.push(`whmcs_id: ${whmcsId}`);
  mountedTags.push(COUNTRY);

  if (zendeskDepartment) {
    mountedTags.push(zendeskDepartment);
  }

  return mountedTags;
}

export default mountZendeskTags;
